import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    seconds: Number
  }

  connect() {
    let seconds = 5
    if (this.hasSecondsValue) {
      seconds = this.secondsValue
    }
    setTimeout(() => {
      useViewTransition(() =>this.element.remove())
    }, seconds * 1000)
  }
}
